import * as entity from '@common/domain/entities/StockItem'
import * as app from '@framework/app';
import { ViewType } from '../../../framework/core/Enums';
import { Permissions } from '../../../config/AppEnums';
export class StockItemEndPoints extends entity.StockItemEndPoints { }

export class StockItemFormFields extends entity.StockItemFormFields {
  constructor() {
    super();
    try {
      this.splice(0, this.length);
      this.push(this.code);
      this.push(this.name);
      this.push(this.description);
      //this.push(this.manufacturerModelNumber);
      this.push(this.stockItemTypeId);
      this.push(this.packagingQuantity);
      this.push(this.minOrderQuantity);
      this.push(this.unitOfMeasureId);
      this.push(this.unitOfMeasureName);
      this.push(this.id);
      this.push(this.stockItemTypeName);
      this.push(this.status);
      this.push(this.datestamp);
      this.push(this.changedById);
      //this.push(this.externalUrl);
      this.push(this.generalLedgerId);
      this.push(this.hierarchyId);

      this.stockItemTypeId.required = true;

      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      if (this["status"]) this.splice(this.indexOf(this["status"]), 1)
      if (this["unitOfMeasureName"]) this.splice(this.indexOf(this["unitOfMeasureName"]), 1)
      if (this["stockItemTypeName"]) this.splice(this.indexOf(this["stockItemTypeName"]), 1)
      this.externalUrl.viewType = ViewType.Link;
      this.stockItemTypeId.name = "Item Type";
      this.unitOfMeasureId.name = "Unit of measure";
      this.generalLedgerId.name = "General Ledger";
      this.generalLedgerId.viewType = ViewType.AutoComplete;
      this.generalLedgerId.dataEndPoint = { url: app.config.controllerRouteRoot + "/GeneralLedger/detail/" };
      this.generalLedgerId.searchEndPoint = { url: app.config.controllerRouteRoot + "/GeneralLedger/search/" };
      this.generalLedgerId.dataDisplayField = "code";
      this.generalLedgerId.dataIdField = "id";

      this.hierarchyId.name = "Hierarchy";
      this.hierarchyId.dataEndPoint = { url: app.config.controllerRouteRoot + "/hierarchy", method: "GET" },
        this.hierarchyId.dataIdField = "id";
      this.hierarchyId.dataDisplayField = "code";
    } catch  { }
  }
}

export class StockItemForm extends entity.StockItemForm {
  protected stockItemFormEndPoints: StockItemEndPoints = new StockItemEndPoints();
  protected stockItemFormFields: StockItemFormFields = new StockItemFormFields();

  public onLoaded: Function = function (context: any, entity?: any) {
    if (!context.authService.hasAnyPermissions(Permissions.StockItemsModuleEdit)) {
      context.parent.componentInstance[0].component.makeFormReadOnly(true)
      context.parent.componentInstance[1].component.makeFormReadOnly(true)
      context.parent.componentInstance[2].component.makeFormReadOnly(true)
      context.parent.componentInstance[3].component.makeFormReadOnly(true)
    }
    else {
      context.parent.componentInstance[0].component.makeFormReadOnly(false)
      context.parent.componentInstance[1].component.makeFormReadOnly(false)
      context.parent.componentInstance[2].component.makeFormReadOnly(false)
      context.parent.componentInstance[3].component.makeFormReadOnly(false)
    }
  }
}

export class StockItemListColumns extends entity.StockItemListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)

    } catch  { }
  }
}

export class StockItemList extends entity.StockItemList {
  protected stockItemListEndPoints: StockItemEndPoints = new StockItemEndPoints();
  protected stockItemListColumns: StockItemListColumns = new StockItemListColumns();
}


export class BladeSetup {
  public onSaveEvent = function (prop) {
    if (prop.listIndex == 0) {
      prop.parent.parent.getBladeByIndex(0).reloadFormByIndex(0);
    }
  }
  public onFormLoad: Function = function (data: any, formIndex?: any, context?: any) {

  }
}
